import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

import { IconFileTypePdf, IconFileWord, IconVideo } from "@tabler/icons-react";

const DropFilesHere = () => {
	return (
		<div
			style={{
				height: "100%",

				backgroundColor: "var(--lxw-main-20)",
				textAlign: "center",
				color: "var(--lxw-main-500)",
				outline: "1px dashed blue",
				outlineOffset: -2,
			}}
		>
			<div style={{ position: "relative", top: "40%" }}>
				<div>
					<IconFileTypePdf
						size={32}
						style={{ margin: 12, transform: "rotate(-15deg)" }}
					/>
					<IconFileWord
						size={32}
						style={{ margin: "12px 12px 16px" }}
					/>
					<IconVideo
						size={32}
						style={{ margin: 12, transform: "rotate(15deg)" }}
					/>
				</div>
				<div style={{ fontSize: 24, fontFamily: "MainFont-SemiBold" }}>
					Drop files here
				</div>
				<div>to upload to this matter</div>
			</div>
		</div>
	);
};

function FileDropzone(props) {
	const onDrop = useCallback((acceptedFiles, fileRejections) => {
		if (fileRejections.length > 0 && props.onFilesRejected) {
			props.onFilesRejected(fileRejections);
		}

		if (acceptedFiles.length === 0) {
			return;
		}

		const reader = new FileReader();

		reader.onabort = () => console.log("file reading was aborted");
		reader.onerror = () => console.log("file reading has failed");
		reader.onload = () => {
			// Do whatever you want with the file contents
			const binaryStr = reader.result;
			console.log(binaryStr);
		};

		//acceptedFiles.forEach(file => console.log(file));
		props.fileHandler(acceptedFiles, () =>
			console.log("drop files complete")
		);
	}, []);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		noClick: true,
		accept: props.accept,
	});

	return props.enabled ? (
		<div
			{...getRootProps()}
			style={{ height: "100%" }}
			className={isDragActive ? " dropzoneDragActive" : ""}
			data-testid={"file-dropzone"}
		>
			<input {...getInputProps()} />
			{isDragActive ? <DropFilesHere /> : props.children}
		</div>
	) : (
		<div style={{ height: "100%" }}>{props.children}</div>
	);
}
export default FileDropzone;
